import { Navigate, Outlet } from "react-router-dom";

const Useauth = () => {
    const token = localStorage.getItem("learn2readToken");
    console.log(token !== null);
    return token !== null;
};

const ProtectedRoutes = () => {
    const isAuth = Useauth();

    return isAuth ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
